import React from "react";
import {Container, MenuItem} from "@mui/material";
import styles from "../PostJobPage/PostJob.module.scss";
import {timePickerOptions} from "../PostJobPage/PostJob.utils";
import clsx from "clsx";
import {FormMaterialSelector} from "components/Selector";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {useForm} from "react-hook-form";
import {joiResolver} from "@hookform/resolvers/joi";
import {JobProps} from "utils/types";
import {useHistory} from "react-router";
import dayjs from "dayjs";
import {TopBarRedesigned} from "../../../components/TopBarRedesigned";
import {HeaderDescription, Value} from "../ConfirmedOfferPage/ConfirmedOfferPage.styles";
import {StyledButton} from "components/Buttons/DefaultButton/DefaultButton.styles";
import useActionApi from "../../../hooks/useActionApi";
import Api from "../../../api";
import FixedLoader from "../../../components/FixedLoader";
import joi from "joi";
import {CrossButtonBlack} from "../../../components/Buttons/CrossButton";
import {SimpleModal} from "../../../components/Modal";

export const schema = joi
    .object({
        from: joi.date().label('From').required(),
        to: joi.date().min(joi.ref('from')).label('To').required(),
    })
    .required()

const ModifyShiftModal = ({ from, to, onSubmit, onCloseButtonClick}: {  from: Date, to: Date, onSubmit: (e: any) => void, onCloseButtonClick: (e: any) => void }) => {
    return (
        <>
            <div className={styles.titleContainer}>
                <div className={styles.popupTitle}>Modify Shift?</div>
                <CrossButtonBlack className={clsx("no-fastclick", styles.crossButtonDark)}
                                  onClick={onCloseButtonClick}/>
            </div>
            <div className={styles.description}>
                {dayjs(from).format('ddd, MMM D, YYYY')}
                <br/>
                {dayjs(from).format('h:mm a')} - {dayjs(to).format('h:mm a')}
            </div>
            <StyledButton
                variant="outlined"
                size="large"
                onClick={onCloseButtonClick}
            >
                Cancel
            </StyledButton>
            <StyledButton
                variant="contained"
                size="large"
                onClick={onSubmit}
            >
                Ok
            </StyledButton>
        </>
    );
}

const ModifyJobPage = () => {
    const history = useHistory();
    const { job } = history.location.state as { job: JobProps }
    const shift = job.shifts[0]
    const [isModifyModalOpen, setIsModifyModalOpen] = React.useState(false);

    const [modifyJobLoading, , modifyJob] = useActionApi({
        apiMethod: Api.modifyJob,
        onSuccess: () => {
            history.goBack()
        },
    });

    const {
        control,
        handleSubmit,
        getValues,
    } = useForm({
        defaultValues: {
            from: dayjs(shift.shiftDate + ' ' + shift.postedStart, 'YYYY-MM-DD HH:mm a').toDate(),
            to: dayjs(shift.shiftDate + ' ' + shift.postedEnd, 'YYYY-MM-DD HH:mm a').toDate(),
        } as any,
        resolver: joiResolver(schema) as any,
    });

    const onSubmit = async (data: any) => {
        setIsModifyModalOpen(false)
        const postedStart = dayjs(data.from).format('YYYY-MM-DD HH:mm')
        const postedEnd = dayjs(data.to).format('YYYY-MM-DD HH:mm')
        modifyJob({jobId: job.id, postedEnd, postedStart})
    }

    const from = getValues('from')
    const to = getValues('to')

    const timeOptsArr = timePickerOptions(dayjs(shift.shiftDate)?.toDate(), 5, 23, 15)

    return (<>
        <TopBarRedesigned
            title={'Modify Shift'}
            onBack={() => {
                history.goBack()
            }}
        />

        <SimpleModal isOpen={isModifyModalOpen}>
            <ModifyShiftModal
                onSubmit={handleSubmit(onSubmit)}
                onCloseButtonClick={() => setIsModifyModalOpen(false)}
                from={from}
                to={to}
            />
        </SimpleModal>

        <Container className={styles.container}>
            <HeaderDescription>
                Edit Shift times
            </HeaderDescription>

                <Value style={{marginBottom: '1rem'}}>Shift Date: {dayjs(shift.shiftDate).format('dddd, MMM D')}</Value>

                <div className={clsx(styles.inputContainer, styles.timePickers)}>
                    <div className={styles.timePickerBox}>
                        <FormMaterialSelector control={control} name={'from'} label={'Arrival Time'}>
                            {[
                                <MenuItem key={'selectArrivalTime'} value={''}>Select Arrival Time</MenuItem>,
                                ...timeOptsArr
                            ]}
                        </FormMaterialSelector>
                        <div className={styles.helperText}>
                            This sets the hourly rate range a temp sees when submitting their offer.
                        </div>
                    </div>
                    <div className={styles.timePickerBox}>
                        <FormMaterialSelector control={control} name={'to'} label={'End Time'}>
                            {[
                                <MenuItem key={'selectEndingTime'} value={''}>Select Ending Time</MenuItem>,
                                ...timeOptsArr
                            ]}
                        </FormMaterialSelector>
                        <div className={styles.helperText}>
                            “End Time” is the time the shift is expected to end - considering last patient, clean-up
                            time and clinical notes.
                        </div>
                    </div>
                </div>

                <div className={styles.bottomContainer}>
                    <StyledButton
                        variant="contained"
                        endIcon={<ArrowForwardIcon/>}
                        color="primary"
                        size="large"
                        id="continue-button"
                        onClick={() => setIsModifyModalOpen(true)}
                    >
                        {`Confirm Change`}
                    </StyledButton>
                </div>
        </Container>
        <FixedLoader loading={modifyJobLoading}/>
    </>)
}

export default ModifyJobPage;